import { useQueryClient } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { useCallback } from "react";

export function useRefresh() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    void queryClient.invalidateQueries();
    navigate(`${location.pathname}${location.search}`, { replace: true });
  }, [queryClient, navigate, location.pathname, location.search]);
}
